var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTimesSquare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.0601 15.0601L22.12 20L27.0601 24.9399C27.6461 25.5259 27.6461 26.476 27.0601 27.062C26.7681 27.354 26.384 27.502 26 27.502C25.616 27.502 25.2319 27.356 24.9399 27.062L20 22.1219L15.0601 27.062C14.7681 27.354 14.384 27.502 14 27.502C13.616 27.502 13.2319 27.356 12.9399 27.062C12.3539 26.476 12.3539 25.5259 12.9399 24.9399L17.88 20L12.9399 15.0601C12.3539 14.4741 12.3539 13.524 12.9399 12.938C13.5259 12.352 14.476 12.352 15.062 12.938L20.002 17.8781L24.942 12.938C25.528 12.352 26.478 12.352 27.064 12.938C27.65 13.524 27.6461 14.4741 27.0601 15.0601ZM39.5 14V26C39.5 33.444 33.444 39.5 26 39.5H14C6.556 39.5 0.5 33.444 0.5 26V14C0.5 6.556 6.556 0.5 14 0.5H26C33.444 0.5 39.5 6.556 39.5 14ZM36.5 14C36.5 8.21 31.79 3.5 26 3.5H14C8.21 3.5 3.5 8.21 3.5 14V26C3.5 31.79 8.21 36.5 14 36.5H26C31.79 36.5 36.5 31.79 36.5 26V14Z",
    fill: "#39383A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimesSquare);
export default __webpack_public_path__ + "static/media/times-square.eca628f1.svg";
export { ForwardRef as ReactComponent };